import { render, staticRenderFns } from "./AllCorridors.vue?vue&type=template&id=5b07e774&scoped=true&"
import script from "./AllCorridors.vue?vue&type=script&lang=js&"
export * from "./AllCorridors.vue?vue&type=script&lang=js&"
import style0 from "./AllCorridors.vue?vue&type=style&index=0&id=5b07e774&scoped=true&lang=css&"
import style1 from "./AllCorridors.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07e774",
  null
  
)

export default component.exports